import React, { memo } from 'react';
import { Star, Quote } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María González',
  role: 'Docente de SIC y Economía',
  city: 'Córdoba Capital',
  age: 42,
  text: 'Hace 15 años que doy clases y siempre sentía que los chicos memorizaban sin entender. Con SIC 360 logré que por fin conecten los conceptos. Las clases ya están armadas, lo que me ahorra horas de planificación los fines de semana.'
}, {
  name: 'Roberto Fernández',
  role: 'Profesor de Contabilidad',
  city: 'Rosario, Santa Fe',
  age: 38,
  text: 'Lo que más valoro es el orden. Antes picoteaba de libros viejos y PDFs de internet. Ahora tengo un camino claro. Mis alumnos de 4to año cambiaron totalmente la actitud, participan más porque entienden la lógica desde el principio.'
}, {
  name: 'Laura Martínez',
  role: 'Docente Nivel Secundario',
  city: 'La Plata, Buenos Aires',
  age: 29,
  text: 'Empecé a dar clases hace poco y me sentía muy insegura improvisando. Este material fue mi salvación. Es como tener un mentor que te dice exactamente cómo explicar cada tema para que los adolescentes te presten atención.'
}, {
  name: 'Esteban Ruiz',
  role: 'Profesor de Gestión',
  city: 'Mendoza',
  age: 51,
  text: "Pensé que a mi edad ya no iba a cambiar mi forma de dar clase, pero me animé a probar. Es increíble cómo cambia la dinámica cuando explicás el 'por qué' antes del 'cómo'. Una herramienta indispensable para el aula de hoy."
}, {
  name: 'Patricia Cabrera',
  role: 'Docente y Contadora',
  city: 'Mar del Plata',
  age: 45,
  text: 'El banco de ejemplos y las evaluaciones listas son oro puro. Dejé de llevarme trabajo a casa. Lo recomiendo a todas mis colegas que sienten que el sistema educativo las está pasando por encima.'
}];
export function TestimonialsSection() {
  return <section className="py-16 bg-slate-50" data-id="element-232">
      <div className="max-w-6xl mx-auto px-4" data-id="element-233">
        <div className="text-center mb-12" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-235">
            Lo que dicen otros docentes
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-236">
            Colegas de todo el país que ya están transformando sus clases con
            SIC 360.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-237">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-8 rounded-xl shadow-sm border border-slate-100 relative hover:shadow-md transition-shadow" data-id="element-238">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-blue-100" data-id="element-239" />
              <div className="flex gap-1 mb-4" data-id="element-240">
                {[...Array(5)].map((_, starI) => <Star key={starI} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-241" />)}
              </div>
              <p className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-242">
                "{t.text}"
              </p>
              <div className="mt-auto" data-id="element-243">
                <p className="font-bold text-slate-900" data-id="element-244">{t.name}</p>
                <p className="text-sm text-slate-500" data-id="element-245">{t.role}</p>
                <p className="text-xs text-slate-400 mt-1" data-id="element-246">
                  {t.city} • {t.age} años
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}